'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var max_size = exports.max_size = 720;
var default_container_id = exports.default_container_id = 'container';

exports.default = { max_size: max_size, default_container_id: default_container_id };


//////////////////
// WEBPACK FOOTER
// ./node_modules/exif-rotate-js/lib/configs.js
// module id = 326
// module chunks = 0